<template>
  <label
    :class="value ? 'radio-button-container checked' : 'radio-button-container'"
    @click="$emit('click')"
  >
    <input id="1234" type="radio" :checked="value" @click.stop>
    {{ label }}

    <span class="checkmark" />
  </label>
</template>

<script>
export default {
  name: 'custom-radio-button',
  props: ['label', 'value'],
  data() {
    return {}
  },
}
</script>

<style scoped>
.radio-button-container {
  display: flex;
  height: fit-content;
  position: relative;
  padding: 0.5rem 1rem 0.5rem 2.875rem;
  border: 1.5px solid #d8d8d8;
  border-radius: 17.5px;
  cursor: pointer;
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 120%;
  letter-spacing: -0.015em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #666666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-button-container.checked {
  background-color: #0277bd;
  color: white;
  border-color: #0277bd;
  border: 1.5px solid ;
}

.checkmark {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 1rem;
  height: 1.225rem;
  width: 1.225rem;
  background-color: transparent;
  border-radius: 50%;
  border: 2px solid #666666;
}

.radio-button-container input:checked ~ .checkmark {
  background-color: #0277bd;
  border: 2px solid white;
}

.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}
</style>
